
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 .5C24.56.5 31.5 7.44 31.5 16c0 8.56-6.94 15.5-15.5 15.5C7.44 31.5.5 24.56.5 16 .5 7.44 7.44.5 16 .5z","fill":"#F8F8F8","stroke":"currentColor"}}),_c('path',{attrs:{"d":"M23.438 23.5v-1.719c0-.911-.38-1.786-1.058-2.43a3.703 3.703 0 00-2.552-1.007H12.61c-.957 0-1.875.362-2.552 1.007A3.356 3.356 0 009 21.78V23.5M16.219 15.25a4.125 4.125 0 100-8.25 4.125 4.125 0 000 8.25z","stroke":"currentColor","stroke-width":"1.4","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    